// Rollout toggles only. The commercial tier is NOT a feature flag — it is `Team.plan`, owned by
// `src/entitlements/plans.ts` and read through `useEntitlement`.
export const FEATURE_FLAGS = {
  DASHBOARD_NEW_DISABLED: 'portfolio_dashboard_disabled',
  NEXOYA_DEMO: 'nexoya_demo',
  SIMULATIONS: 'simulations',
  GOOGLE_ADS_CAMPAIGN_MANAGEMENT: 'google_ads_campaign_management',
  ATTRIBUTION_MODEL: 'attribution_model',
  CALCULATED_METRIC: 'calculated_metric',
  // `app_assistant_ai` is the name the backend actually provisions — not `app_assistant`.
  APP_ASSISTANT: 'app_assistant_ai',
  // Content Labels. v2 is a separate, team-scoped UI over its own data; nothing is copied
  // from the portfolio-scoped labels, so a team can run both. HIDE_LEGACY_PORTFOLIO_LABELS is
  // opt-IN: only a team that has it switched on loses the old labels (see useLabelsFlags).
  HIDE_LEGACY_PORTFOLIO_LABELS: 'hide_legacy_portfolio_labels',
  LABELS_V2: 'content_labels_v2',
  TREND_SIGNALS: 'trend_signals',
};

export const PORTFOLIO_FEATURE_FLAGS = {
  SELF_SERVICE_PORTFOLIO: 'self_service_portfolio',
  ATTRIBUTION: 'attribution',
  WHAT_IF_VALIDATION: 'what_if_validation',
  OPTIMIZATION_VISIBLE_TO_ALL_USERS: 'optimizationsOnlyVisibleToSupportUsers',
  SIMULATION_PREVIEW_SUPPORT: 'simulation_preview_support',
};
